module.exports = __webpack_public_path__ + "img/excel.eb552edd.png";